export type ValidationFlags = any;

export type CriteriaDetails = any;

export type PeriodTime = string | number;

export interface Period {
	name?: string;
	from?: PeriodTime;
	to?: PeriodTime;
	price?: number;
}

export interface Rate {
	id?: number;
	profile_id?: number;
	name?: string;
	periods?: Period[];
}

export interface Criterion {
	name?: string;
	type?: number;
	details?: CriteriaDetails;
}

export interface Category {
	id?: number;
	profile_id?: number;
	name?: string;
	rate_id?: number;
	criteria?: Criterion[];
	show?: boolean;
}

export interface Profile {
	id?: number;
	name?: string;
	currency?: number;
	rates?: number[];
	categories?: number[];
	is_special?: boolean;
	sites_count?: number;
}

export interface ProfileSite {
	id: number;
	name: string;
	customer_id: number;
	customer_name?: string;
}

export interface ProfileInfoResponse {
	profile: Profile;
	rates: Rate[];
	categories: Category[];
}

export interface SaveProfileResponse {
	profileId?: number;
	invalidFields?: ValidationFlags;
}

export interface DeleteProfileResponse {
	deleted: boolean;
	reason?: string;
	sitesCount?: number;
}

export interface ReplaceProfileResponse {
	replaced: boolean;
	reason?: string;
	movedSites?: number;
}

export const CURRENCY = [
	{ id: 1, name: '$' },
	{ id: 2, name: 'C$' },
	{ id: 3, name: 'A$' },
	{ id: 4, name: '€' },
	{ id: 5, name: '£' }
];

export const CRITERIA_TYPES = {
	PERIOD_OF_YEAR: 1,
	DAYS_OF_WEEK: 2,
	FIXED_DATE: 3,
	FIRST_DAY_OF_MONTH: 4,
	SECOND_DAY_OF_MONTH: 5,
	THIRD_DAY_OF_MONTH: 6,
	FORTH_DAY_OF_MONTH: 7,
	LAST_DAY_OF_MONTH: 8,
	YEAR: 9
};

export const DAYS = {
	SUNDAY: 1,
	MONDAY: 2,
	TUESDAY: 3,
	WEDNESDAY: 4,
	THURSDAY: 5,
	FRIDAY: 6,
	SATURDAY: 7
};

export const MONTHS = {
	JANUARY: 1,
	FEBRUARY: 2,
	MARCH: 3,
	APRIL: 4,
	MAY: 5,
	JUNE: 6,
	JULY: 7,
	AUGUST: 8,
	SEPTEMBER: 9,
	OCTOBER: 10,
	NOVEMBER: 11,
	DECEMBER: 12
};

export const MAX_RATES = 8;
export const MAX_PERIODS = 8;
export const MAX_CRITERIA = 4;
export const MAX_NAME_LENGTH = 100;

export const DAY_SECONDS = 24 * 60 * 60;
export const HOUR_SECONDS = 60 * 60;
export const MINUTE_SECONDS = 60;

export const YEARS_AHEAD = 10;

export const MONTH_DAYS = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
